import { projectHomeRedirect } from "@/features/projects/utils/project-home-destination";
import { createFileRoute } from "@tanstack/react-router";

// CR-144: the bare project root has no page of its own. It lands on the first
// enabled module (Change Requests → Tasks → AI Chats → Documents), replacing
// the root in the history so Back does not bounce through the redirect.
export const Route = createFileRoute("/_authenticated/workspaces/$slug/projects/$projectSlug/")({
  beforeLoad: ({ context, params }) => {
    throw projectHomeRedirect(context.project, params, context.workspaceAccess);
  },
});
